import DownloadIcon from "../view/assets/icons/DownloadIcon.vue";
import { goDateString } from "./common";

export const BULK_SYNC_BUTTON = "kot-bulk-sync-button";
const KOT_MAIN_SELECTION_BUTTON = "kot-holiday-button"

export function bulkSync(startDate, endDate) {
  $(`#${KOT_MAIN_SELECTION_BUTTON}`).addClass('loading');
  const data = JSON.stringify({
    "startDate": goDateString(startDate),
    "endDate": goDateString(endDate),
  });

  fetch(DashURL("kot/bulk-sync"),{method: "POST", body: data}).then(response => {
    $(`#${KOT_MAIN_SELECTION_BUTTON}`).removeClass('loading');
    if (!response.ok) {
      response.text().then(errorMsg => {
        alertModal.alert(`同期に失敗しました: ${errorMsg}`, true)
      })
    } else {
      response.json().then(json => {
        let msg = "同期に成功しました。";
        if (json.internalErr == null && json.apiErrDetailsURL == null) {
          alertModal.alertSuccess(msg, true);
          return;
        }

        msg = "シフトの同期中にエラーが発生しました。"
        if (json.internalErr != null) {
          msg += `\nOplusからのエラー: ${json.internalErr}`;
        }

        if (json.apiErrDetailsURL != null) {
          msg += "\nAPIエラーが発生しました。詳細はファイルをダウンロードしてご確認ください。";
          alertModal.confirm(
            msg,
            () => { downloadShiftSyncAPIErrorsFile(json.apiErrDetailsURL); },
            null,
            "出力",
            DownloadIcon,
          );
          return;
        }

        alertModal.alert(msg, true);
      })
    }
  })
}

async function downloadShiftSyncAPIErrorsFile(url) {
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`failed to download file`);
  }

  const blob = await response.blob();
  const blobURL = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = blobURL;

  const now = new Date();

  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, "0")
  const day = String(now.getDate()).padStart(2, "0")
  const hour = String(now.getHours()).padStart(2, "0")
  const minute = String(now.getMinutes()).padStart(2, "0")

  const formattedDate = `${year}年_${month}月_${day}日_${hour}時_${minute}分`;

  a.download = `kot_エラー_${formattedDate}.csv`

  document.body.appendChild(a);
  a.click();
  a.remove();

  URL.revokeObjectURL(blobURL);
}
